const researchPapers = [
  {
    title:
      "A Comprehensive Multi-Model Framework for Lung Cancer Image Classification Integrating Advanced Deep Learning and Explainable AI",
    link: "https://scholar.google.com/",
  },

  {
    title:
      "Skin Cancer Classification using EfficientNetV2-L",
    link: "https://scholar.google.com/",
  },
];

export default researchPapers;